import { initialStateBase, reducer } from './newCollection';

export const baseUrl = '/api/re-projects/v1/real-estate/business';

export const urls = {
    getLeadFormConfig: `${baseUrl}/leads/configs`,
    getLeadFormData: `${baseUrl}/leads/form`,
    submitLeadForm: `${baseUrl}/leads`
};

const initialState = Object.assign({}, initialStateBase, {
    metadataKey: 'leadFormConfig'
});

export default (state = initialState, action) => {
    switch (action.type) {
        case 'ERROR_LEAD_FORM':
        case 'REQUEST_LEAD_FORM_DATA':
            return reducer(state, action, 'LEAD_FORM_DATA');
        case 'RECEIVE_LEAD_FORM_DATA': {
            const newState = {
                ...state,
                leadFormData: action.data && action.data.data
            };

            return reducer(newState, action, 'LEAD_FORM_DATA');
        }
        case 'RECEIVE_LEAD_FORM_CONFIG': {
            return reducer(state, action, 'LEAD_FORM_CONFIG');
        }

        default:
            return state || null;
    }
};
